import type { RouteRecordRaw } from 'vue-router';

export const cAUTH_ROUTES = {
  auth: {
    path: 'auth',
    name: 'AuthERP',
    component: () => import('@/layouts/blank/BlankLayout.vue'),
    meta: {
      requiresAuth: false,
    },
  },

  loginERP: {
    path: 'login',
    name: 'LoginERP',
    component: () => import('@/modules/auth/erp/AuthERP.vue'),
  },
};

export const authRoutes: Array<RouteRecordRaw> = [
  {
    path: cAUTH_ROUTES.auth.path,
    component: cAUTH_ROUTES.auth.component,
    meta: {
      requiresAuth: cAUTH_ROUTES.auth.meta.requiresAuth,
    },
    children: [
      {
        path: cAUTH_ROUTES.loginERP.path,
        name: cAUTH_ROUTES.loginERP.name,
        component: cAUTH_ROUTES.loginERP.component,
      },
    ],
  },
];
